export default __webpack_public_path__ + "static/media/logo-white.0dc19b8d.webp";